import React from 'react';
import { Search, Plus, X } from 'lucide-react';

const AddVisitTypeModal = ({ isOpen, onClose, onSelectTemplate, onCreateNew }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-medium">Add Visit Type</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <button
            onClick={onSelectTemplate}
            className="w-full p-6 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-gray-100 rounded-lg">
                <Search className="h-6 w-6 text-gray-600" />
              </div>
              <div>
                <h3 className="font-medium">Search existing templates</h3>
                <p className="text-sm text-gray-500">Find and customize pre-built visit types</p>
              </div>
            </div>
          </button>

          <button
            onClick={onCreateNew}
            className="w-full p-6 text-left border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-gray-100 rounded-lg">
                <Plus className="h-6 w-6 text-gray-600" />
              </div>
              <div>
                <h3 className="font-medium">Create from scratch</h3>
                <p className="text-sm text-gray-500">Build a custom visit type</p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddVisitTypeModal; 